module.exports = __webpack_public_path__ + "img/ic_service_item_img4.55f57038.png";